module.exports = __webpack_public_path__ + "media/reskin-images/icon--history-0256cd75.svg";